import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})

export class WelcomeComponent implements OnInit {

  @ViewChild('roleInput', { static: false }) roleInput: ElementRef<HTMLInputElement>;
  @ViewChild('RoleAuto', { static: false }) matAutocomplete: MatAutocomplete;

  public options: any;
  public value: string[];

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  roleCtrl = new UntypedFormControl();
  filteredRoles: Observable<string[]>;
  roles: string[] = [];
  noOfTechinicalRoles: any;
  allRoles: string[] = [];

  questionFirst = {
    name: 'Which of the following have you done in the past ?',
    type: 'checkbox',
    label: 'question1',
    options: [
      { name: 'Create manual or email assessments', checked: false },
      { name: 'Use another coding assessment platform?', checked: false },
      { name: 'Pass unqualified candidates along to engineering ?', checked: false },
      { name: 'Develop my own Technical expertise to assess Candidates?', checked: false },
      { name: 'None of the above.', checked: false }]
  };

  questionSecond = {
    name: 'Where did you originally hear about Evaltrix?',
    type: 'radio',
    label: 'question2',
    options: [
      { name: 'Google search result.' },
      { name: 'Google search ad' },
      { name: 'Medium article' },
      { name: 'social media article, post, or ad' },
      { name: 'Friend or coworker' },
      { name: 'Sales rep contacted me' },
      { name: 'Capterra or G2' },
      { name: 'Somewhere else' },
      { name: 'I don"t remember' }
    ]
  };

  questionSecondAnswer: string;

  constructor(
    public router: Router,
    private httpService: ApiService) {
    this.filteredRoles = this.roleCtrl.valueChanges.pipe(startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allRoles.slice()));
  }

  ngOnInit() {
    this.value = [];
    this.options = {
      multiple: true,
      tags: true
    };
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      this.roles.push(value.trim());
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.roleCtrl.setValue(null);
  }

  addOnBlur(event: FocusEvent) {
    const target: HTMLElement = event.relatedTarget as HTMLElement;
    if (!target || target.tagName !== 'MAT-OPTION') {
      const matChipEvent: any = { input: this.roleInput.nativeElement, value: this.roleInput.nativeElement.value };
      this.add(matChipEvent);
    }
  }

  radioButtonChangEvent(event) {
    this.questionSecondAnswer = event.value;
  }

  remove(role: string): void {
    const index = this.roles.indexOf(role);
    if (index >= 0) {
      this.roles.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.roles.push(event.option.viewValue);
    this.roleInput.nativeElement.value = '';
    this.roleCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allRoles.filter(option => option.toLowerCase().includes(filterValue));
  }

  submitProfile() {
    const questionAnswers = [];
    this.questionFirst.options.map(item => {
      if (item.checked) {
        questionAnswers.push(item.name);
      }
    });
    const reqObj = {
      profileStats: [
        { question: this.questionFirst.name, answers: questionAnswers },
        { question: this.questionSecond.name, answers: [this.questionSecondAnswer] },
        { question: 'roles', answers: this.roles },
        {
          question: 'How many technical roles Do you plan to screen and hire for the Next 12 months.',
          answers: [this.noOfTechinicalRoles]
        }
      ]
    };
    this.httpService.submitProfile(reqObj).subscribe(() => {
      this.router.navigate(['/dashboard/settings']);
    });
  }

}
